<app-feature-details-grid>
  <app-feature-list-container>
    <app-feature-list-item
      *ngIf="saltLevelDays$ | async | ready as feature"
      label="{{ '+INSTALLATIONS.INSTALLATION.ECOWATER.SALT_LEVEL.TITLE' | translate }}"
      [value]="feature.properties?.remaining | translateEcowaterRemainingProperty"
      [attr.data-feature]="feature.feature"
    >
    </app-feature-list-item>
    <ng-container *ngIf="leakDetection | ready as feature">
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.ECOWATER.FLOW_VALUE' | translate }}"
        value="{{ feature | value2: featurePropertyKey.maxFlow }} {{
          feature | unit: featurePropertyKey.maxFlow
        }}"
        [attr.data-feature]="feature.feature + '/maxFlow'"
        labelInfoTooltip="{{
          '+INSTALLATIONS.INSTALLATION.ECOWATER.FLOW_VALUE_TOOLTIP' | translate
        }}"
        [editable]="true"
        (edit)="openEditModal(true)"
      >
      </app-feature-list-item>
      <app-feature-list-item
        label="{{ '+INSTALLATIONS.INSTALLATION.ECOWATER.FLOW_DURATION' | translate }}"
        value="{{ feature | value2: featurePropertyKey.maxDuration }} {{
          feature | unit: featurePropertyKey.maxDuration
        }}"
        [attr.data-feature]="feature.feature + '/maxDuration'"
        labelInfoTooltip="{{
          '+INSTALLATIONS.INSTALLATION.ECOWATER.FLOW_DURATION_TOOLTIP' | translate
        }}"
        [editable]="true"
        (edit)="openEditModal(false)"
      >
      </app-feature-list-item>
    </ng-container>
  </app-feature-list-container>
</app-feature-details-grid>
